// extracted by mini-css-extract-plugin
export default {"mobileViewWidget":"view-widget_mobileViewWidget__TBgBk"};